import React, { Fragment, Suspense, useContext, useState } from 'react';
import { Button, Spinner, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../ErrorBoundary';
import { ErrorComponent } from '../ErrorComponent';
import { NoDataComponent } from '../NoDataComponent';
import { fetchTroublesAll, useResolveTrouble } from '../../utils/dashboard-hooks';
import { Trouble } from '../../models/dashboard-models';
import { resourceCache } from 'use-async-resource';
import { BranchesContext } from '../../context/BranchesContext';
import { checkered } from '../../styles/selectStyles';
import { AddTrouble } from '../../pages/AddTrouble';
import { AddActionComponent } from '../AddActionComponent';
import { faCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Troubles = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { fetchNewTroubles } = useContext(BranchesContext);

    const refetchEntitiesHook = async () => {
        resourceCache(fetchTroublesAll).clear();
        fetchNewTroubles();
    };

    return (
        <>
            <Tab.Pane eventKey='third' className='p-2 w-100 overflow-auto '>
                <AddActionComponent
                    buttonClass={'w-100'}
                    title={t('addTrouble')}
                    addComponent={AddTrouble}
                    {...{ refetchEntitiesHook }}
                ></AddActionComponent>
                <ErrorBoundary fallback={<ErrorComponent errorText={t('troubles')} />}>
                    <Suspense fallback={<Spinner animation='border' />}>
                        <TroublesInner></TroublesInner>
                    </Suspense>
                </ErrorBoundary>
            </Tab.Pane>
        </>
    );
};

const TroublesInner = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [shownIndex, setShownIndex] = useState(-1);
    const { getTroubles, fetchNewTroubles } = useContext(BranchesContext);
    const troubles = getTroubles();

    const onClickHandler = (index: number) => {
        const updatedIndex = shownIndex === index ? -1 : index;
        setShownIndex(updatedIndex);
    };

    const ResolveHandler = async (trouble: Trouble) => {
        await useResolveTrouble(trouble.id);
        resourceCache(fetchTroublesAll).clear();
        fetchNewTroubles();
    };

    return (
        <>
            {troubles.length > 0 ? (
                troubles.map((trouble, index) => (
                    <Fragment key={index}>
                        {!trouble.resolved && (
                            <div className={`d-flex branch flex-column w-100 my-2 ${checkered(index)}`} key={index}>
                                <div
                                    className='d-flex align-items-center reminder hovered-row'
                                    onClick={() => onClickHandler(index)}
                                >
                                    <div className='d-flex align-items-center mb-0 px-1 py-2 w-100'>
                                        <p className='w-100 mb-0'>
                                            {trouble.branchName} {trouble.branchAddress}
                                        </p>
                                        <FontAwesomeIcon
                                            icon={faExclamationTriangle}
                                            color={'#FF0000'}
                                            className='mx-1'
                                        ></FontAwesomeIcon>
                                    </div>
                                </div>
                                {shownIndex === index && (
                                    <div className='p-2 mt-0 reminder d-flex flex-wrap justify-content-end'>
                                        <div className='pr-1 mb-0 w-100'>
                                            <p>{trouble.description}</p>
                                        </div>
                                        <Button
                                            size='sm'
                                            type='submit'
                                            className='mx-1  mt-2 btn-success'
                                            onClick={() => ResolveHandler(trouble)}
                                        >
                                            {t('resolve')}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </Fragment>
                ))
            ) : (
                <div className='h-100 d-flex align-items-center w-100'>
                    <NoDataComponent noDataText={t('troubles')}></NoDataComponent>
                </div>
            )}
        </>
    );
};
